import { render, staticRenderFns } from "./corporate_stream.vue?vue&type=template&id=0d70e9de&"
import script from "./corporate_stream.vue?vue&type=script&lang=js&"
export * from "./corporate_stream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports